module.exports = __webpack_public_path__ + "3dc00424e.jpg";